import { useEffect, useState } from "react";

const REDIRECT_URL = "https://bountydbot.site";
const COUNTDOWN_SECONDS = 5;

export default function SiteSuspended() {
  const [secondsLeft, setSecondsLeft] = useState(COUNTDOWN_SECONDS);

  useEffect(() => {
    if (secondsLeft <= 0) {
      window.location.href = REDIRECT_URL;
      return;
    }
    const timer = setTimeout(() => setSecondsLeft((s) => s - 1), 1000);
    return () => clearTimeout(timer);
  }, [secondsLeft]);

  return (
    <div style={styles.overlay}>
      <div style={styles.card}>
        <h1 style={styles.title}>SITE SUSPENDED</h1>
        <p style={styles.text}>
          This site is no longer available. You are being redirected to another
          site.
        </p>
        <p style={styles.countdown}>
          Redirecting in {secondsLeft} second{secondsLeft === 1 ? "" : "s"}...
        </p>
        <button
          style={styles.button}
          onClick={() => (window.location.href = REDIRECT_URL)}
        >
          Continue
        </button>
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: "fixed",
    inset: 0,
    zIndex: 9999,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "rgba(15, 15, 15, 0.96)",
    padding: "1rem",
  },
  card: {
    maxWidth: 420,
    width: "100%",
    textAlign: "center",
    background: "#1a1a1a",
    border: "1px solid #333",
    borderRadius: 12,
    padding: "2rem",
    color: "#fff",
    fontFamily: "system-ui, sans-serif",
  },
  title: {
    fontSize: "1.75rem",
    fontWeight: 700,
    letterSpacing: "0.05em",
    marginBottom: "0.75rem",
    color: "#ff4d4d",
  },
  text: {
    fontSize: "1rem",
    marginBottom: "1rem",
    color: "#ccc",
  },
  countdown: {
    fontSize: "0.9rem",
    marginBottom: "1.5rem",
    color: "#999",
  },
  button: {
    padding: "0.6rem 1.5rem",
    fontSize: "1rem",
    fontWeight: 600,
    borderRadius: 8,
    border: "none",
    background: "#ff4d4d",
    color: "#fff",
    cursor: "pointer",
  },
};
